import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Toolbox } from '@core-ds/icons/24';
import Dropdown from './dropdown';
import Workbench from 'Shared/workbench';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';
import { useDisclosure } from '@chakra-ui/react';

const Icon = styled(Toolbox)`
   cursor: pointer;
   color: ${color.gray[400]};
`;

const mapStateToProps = (state: any) => ({
   userTopics: state.headerState.userTopics,
});

interface WorkbenchDropdownProps {
   userTopics: any;
}

const WorkbenchDropdown = (props: WorkbenchDropdownProps) => {
   const { isOpen: tippyToggle, onToggle: onTippyToggle } = useDisclosure({ defaultIsOpen: true });
   const onMount = () => {
      trackInMatomoAndGA({
         eventCategory: 'Workbench',
         eventAction: 'Workbench - Click',
      });
   };

   return (
      <Dropdown
         label="View Workbench"
         onMount={onMount}
         icon={<Icon id="workbenchDropdownToggle" aria-label="my workbench" focusable="false" />}
         hideOnClick={tippyToggle}
      >
         <Workbench topics={props.userTopics} onTippyToggle={onTippyToggle} />
      </Dropdown>
   );
};

export default connect(mapStateToProps)(WorkbenchDropdown);
